export default [
  {
    name: 'Emma Smith',
    locale: 'gb',
    city: 'London',
    role: 'Influencer',
    platform: 'instagram',
    interaction: 'likes',
    date: '2023-11-05',
    image: 'Female-1.jpg',
    testimonial: 'Crazy how fast everything happened! I placed an order, and within minutes, the likes started rolling in. So smooth!',
  },
  {
    name: 'Daniel Svensson',
    locale: 'se',
    city: 'Göteborg',
    role: 'Egenföretagare',
    platform: 'instagram',
    interaction: 'followers',
    date: '2022-06-18',
    image: 'Male-1.jpg',
    testimonial: 'Behövde få fler följare på mitt företagskonto och det här gjorde verkligen jobbet. Märker redan skillnad i räckvidden!',
  },
  {
    name: 'Sara Nilsen',
    locale: 'no',
    city: 'Oslo',
    role: 'TikTok Creator',
    platform: 'tiktok',
    interaction: 'views',
    date: '2021-09-22',
    image: 'Female-2.jpg',
    testimonial: 'Videoene mine fikk ikke den rekkevidden jeg håpet på, men etter en boost tok de virkelig av! Superfornøyd!',
  },
  {
    name: 'Johan Mikkelsen',
    locale: 'dk',
    city: 'Aarhus',
    role: 'Musiker',
    platform: 'tiktok',
    interaction: 'followers',
    date: '2020-12-30',
    image: 'Male-2.jpg',
    testimonial:
      'Som musiker er det vigtigt at være synlig på sociale medier. Dette hjalp mig med at nå flere mennesker og få opmærksomhed omkring min musik!',
  },
  {
    name: 'Nathalie Schmidt',
    locale: 'de',
    city: 'Berlin',
    role: 'Lifestyle-Bloggerin',
    platform: 'instagram',
    interaction: 'likes',
    date: '2024-02-10',
    image: 'Female-3.jpg',
    testimonial: 'So unglaublich einfach zu nutzen, und ich konnte sogar mit Klarna bezahlen! Perfekt für alle, die schnell wachsen wollen.',
  },
  {
    name: 'Marcus Johnson',
    locale: 'gb',
    city: 'Manchester',
    role: 'Entrepreneur',
    platform: 'instagram',
    interaction: 'followers',
    date: '2023-03-15',
    image: 'Male-3.jpg',
    testimonial: 'I wanted to increase my visibility and strengthen my brand. This was a great solution, and the delivery was super fast.',
  },
  {
    name: 'Isabelle Kristiansen',
    locale: 'no',
    city: 'Bergen',
    role: 'Fotograf',
    platform: 'instagram',
    interaction: 'views',
    date: '2021-07-28',
    image: 'Female-4.jpg',
    testimonial: 'Bildene mine fortjener flere øyne på seg! Dette hjalp meg med å nå ut og få flere til å oppdage arbeidet mitt.',
  },
  {
    name: 'Lukas Hansen',
    locale: 'dk',
    city: 'Copenhagen',
    role: 'E-sportsudøver',
    platform: 'tiktok',
    interaction: 'views',
    date: '2020-05-12',
    image: 'Male-4.jpg',
    testimonial:
      'Gaming og sociale medier går hånd i hånd – og at få flere visninger på mine klip har virkelig hjulpet mig med at opbygge et publikum!',
  },
  {
    name: 'Sofia Müller',
    locale: 'de',
    city: 'Hamburg',
    role: 'Marketing-Studentin',
    platform: 'instagram',
    interaction: 'followers',
    date: '2022-10-01',
    image: 'Female-5.jpg',
    testimonial:
      'Ich wollte verschiedene Wachstumsstrategien auf Instagram ausprobieren, und das war eine großartige Möglichkeit, meine Reichweite schnell zu erhöhen!',
  },
  {
    name: 'Anton Williams',
    locale: 'gb',
    city: 'Birmingham',
    role: 'Fitness Coach',
    platform: 'instagram',
    interaction: 'likes',
    date: '2024-01-20',
    image: 'Male-5.jpg',
    testimonial: 'Getting more likes on my fitness videos has really boosted my account! Big plus that everything was delivered quickly.',
  },
  {
    name: 'Hanna Weber',
    locale: 'de',
    city: 'Munich',
    role: 'Fashion Influencer',
    platform: 'instagram',
    interaction: 'likes',
    date: '2023-05-15',
    image: 'Female-6.jpg',
    testimonial: 'Ich habe bemerkt, dass mehr Engagement zu mehr Kooperationen führt. Dieser Service hat wirklich einen Unterschied gemacht!',
  },
  {
    name: 'Oscar Larsen',
    locale: 'no',
    city: 'Stavanger',
    role: 'YouTuber',
    platform: 'tiktok',
    interaction: 'views',
    date: '2021-04-17',
    image: 'Male-6.jpg',
    testimonial: 'Jeg markedsfører mine YouTube-videoer på TikTok og ønsket flere visninger – dette fungerte perfekt!',
  },
  {
    name: 'John Walker',
    locale: 'us',
    city: 'New York',
    role: 'Content Creator',
    platform: 'instagram',
    interaction: 'followers',
    date: '2024-02-20',
    image: 'Male-7.jpg',
    testimonial: 'Building an audience is tough, but this service made it so much easier. My reach has grown significantly!',
  },
  {
    name: 'Emily Roberts',
    locale: 'us',
    city: 'Los Angeles',
    role: 'YouTuber',
    platform: 'tiktok',
    interaction: 'views',
    date: '2023-08-15',
    image: 'Female-7.jpg',
    testimonial: 'I use TikTok to drive traffic to my YouTube channel, and this gave me the boost I needed. Super effective!',
  },
];
